// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper tr:nth-child(odd) {\n  background: white !important;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/reports/tabsAccounting/table.less"],"names":[],"mappings":"AACA;EACE,4BAAA;AAAF","sourcesContent":["\n.wrapper tr:nth-child(odd) {\n  background: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
